import(/* webpackMode: "eager" */ "/vercel/path0/src/app/profile/page.tsx");
